// extracted by mini-css-extract-plugin
export default {"cls1":"SimplePaperPodcast-cls1_d8P","cls2":"SimplePaperPodcast-cls2_IcH SimplePaperPodcast-cls1_d8P"};